var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n.cls-1{\n  fill:#3C4149; \n  stroke: #3C4149;\n  stroke-width: 8px;\n}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,128a191.12,191.12,0,0,0-64,11V106.67a64,64,0,0,1,126-16A21.33,21.33,0,0,0,359.32,80a106.69,106.69,0,0,0-210,26.67v53.77A192,192,0,0,0,64,320c0,105.86,86.13,192,192,192s192-86.14,192-192S361.87,128,256,128Zm0,341.33c-82.34,0-149.33-67-149.33-149.33s67-149.33,149.33-149.33,149.33,67,149.33,149.33S338.34,469.33,256,469.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,234.67A64,64,0,0,0,234.67,359v46.34a21.33,21.33,0,0,0,42.67,0V359A64,64,0,0,0,256,234.67ZM256,320a21.33,21.33,0,1,1,21.33-21.33A21.36,21.36,0,0,1,256,320Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.23938a23a8e982e1868a5e51dedcc57e.svg";
export { ForwardRef as ReactComponent };